import React from "react";
import "./sidebar.css";
import Price from "./price/Price";
import Colors from "./color/Colors";
import Category from "./category/Category";

export default function Sidebar({ handleChange }) {
  return (
    <div className="sidebar">
      <Category handleChange={handleChange} />
      <Price handleChange={handleChange} />
      <Colors handleChange={handleChange} />
    </div>
  );
}
